var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-delete-patient-button"},[_c('button',{staticClass:"delete-patient-button",attrs:{"type":"button","data-test":"del-patient-btn"},on:{"click":_vm.handleClick}},[_vm._m(0),_c('span',{staticClass:"delete-patient-button-text"},[_vm._v(_vm._s(_vm.$t('common.delete')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"delete-icon"},[_c('span',{staticClass:"cross-mark"})])
}]

export { render, staticRenderFns }